
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Despejado`,
'deleteKey': `⌦ Suprimir`,
'downKey': `↓ Abajo`,
'endKey': `⤓ Fin`,
'enterKey': `Entre en`,
'escapeKey': `⎋ Escape`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Generar una 
          <code>LICENCIA 
          </code> archivo 
        `,
'homeKey': `⤒ Inicio`,
'keyCommand': `⌘ Comando/Ganar`,
'keyControl': `^ Control`,
'keyOption': `⌥ Opción/Alt`,
'keyShift': `⇧ Turno`,
'leftKey': `← Izquierda`,
'pagedownKey': `▼ Pagedown`,
'pageupKey': `Página anterior`,
'rightKey': `→ Derecha`,
's00065e45db8c0441': `Para más información, consulte las herramientas para desarrolladores`,
's001dd78415a91fa0': `Canal de la barra de desplazamiento`,
's002fa7d1054ed082': `Cuadro de bordes`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Kazajstán`,
's01b56d233c6c5cac': `Seccionamiento`,
's01d32b35baa3b676': `Autor`,
's02106cc2ef0e7578': `Nuevo pin...`,
's02ab1ea8e5100fc1': `Marcar la selección como "anulación bidireccional".`,
's0312976fe9da5951': `Botón`,
's03608a32f05eded2': `Pellizcar zoom`,
's036d35e03be98d22': `Profundidad matemática`,
's037b1dc850a89273': `Suplente en`,
's0396202b716732ec': `Marcar la selección como tachada`,
's03f49e598ffb11cc': `Polaco`,
's0448f1059fa01720': `Guarda, comparte o imprime tu explorable. Edita información como el título, el idioma o la licencia.`,
's0458872c43beadef': `Insertar fila antes de`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Espaciado entre palabras`,
's05e9759cfd99c48f': `Justificar`,
's063fa5a0a4903bf4': `Lateral, de izquierda a derecha`,
's064339c229374050': `Codificación`,
's06634274f19b0572': `Selección de clavijas`,
's06743b24499f0035': `Centro de anclaje`,
's07808b0ca6da8fef': `Sitio Web vallado`,
's07970793b21351fd': `Contenedor base Ruby`,
's079cf7850d9327f0': `Fuente`,
's07aa10850d9ddcc7': `Formulario`,
's07e6118e838b2e23': `Navegación`,
's0816468df86e4036': `Abre los ajustes`,
's082869038c117fe5': `Portugués (Brasil)`,
's086e6c267ade2609': `Saturación`,
's08e12ade32ef8125': `Setsuana`,
's08e6bd98452e6bb9': `Audio`,
's0978fb5ba3145996': `Insertar una lista (desordenada)`,
's09c3f1d21de14ae1': `Marcar la selección como subrayada`,
's0a2d91c6720033e9': `Recorte de espaciado de texto`,
's0a3ddcba94027d95': `Ajuste del objeto`,
's0a6cb8d42cdb0c4a': `Esperanto`,
's0a799f583098cadf': `Insertar una navegación`,
's0a7db790db1fc45c': `Marcar la selección como tramo`,
's0b1271f50a77dc73': `Caja de contenido`,
's0b24d08ea349b455': `Todo lo que se puede insertar. Al principio están los elementos no interactivos como listas o imágenes, a continuación están los elementos interactivos llamados widgets. Puedes conseguir nuevos haciendo clic en la barra de búsqueda.`,
's0bdca49248ba4820': `Atajos`,
's0befccf152b6c0a9': `Orientar a partir de metadatos`,
's0c11e479416c8421': `Insertar un título de tabla`,
's0c27336067c59611': `Relleno de desplazamiento`,
's0c4593d81f147042': `Línea de base`,
's0c4b2e98d4ab7f5a': `Comandos de la aplicación`,
's0c883713b83616a8': `Guardar el documento activo`,
's0ca5c0460199cba1': `Abreviatura`,
's0cf10c4f40588f8d': `Leyenda de la tabla`,
's0d86afa3c6a1e28b': `Dirección flexible`,
's0dad143dff0079fc': `Malayalam`,
's0db05bd7ba6fff96': `Tu documento explorable. Aquí puedes escribir texto y copiar/pegar, editar, etc.`,
's0dc452999c129e15': `Activar la recarga en directo`,
's0de0febab8a4beaf': `Error al leer este paquete`,
's0e44968489e076a8': `Chino`,
's0e4862e87c7d53ce': `Marcar la selección como cita`,
's0e6ea8870dbddab2': `Comandos de documentos`,
's0ee28503778e4c0c': `Última referencia`,
's0ef01c03299bbb83': `Decoración`,
's0f17f32919661cff': `Mongolia`,
's0f350bc4e538e3ea': `Palabras`,
's105a06836c40fcb4': `Establezca los filtros, el color y la mezcla de los elementos seleccionados`,
's106b274b5af798e5': `Frases`,
's1082e1649793dca9': `Marcar la selección como término definido`,
's10f3845975a0351e': `Editar metadatos`,
's1125d159f7e64df5': `Mostrar`,
's11326fd2590f4e5e': `Por defecto`,
's1155ec07a221e739': `Barra de desplazamiento`,
's1173bf7a3e0b74c9': `Mínimo (y)`,
's1177237a3e0e548c': `Mínimo (x)`,
's1219d97b49650c05': `Visibilidad`,
's123bea44f38abccf': `Insertar objeto`,
's1245e2cb9f20197e': `Alinear`,
's12946ec1b850962c': `Insertar columna después de`,
's1351209ef74ee729': `Extender todas las columnas`,
's13c60cb409e8cb6f': `Alinear al centro`,
's13ebd619c8a06a6d': `Rejilla autofilas`,
's13ef8ca26ca8861b': `Elemento de corte`,
's151bc2eea7a032a4': `-unchanged-`,
's153bc3c3aa39587b': `Cabezal de mesa`,
's156647179b21d351': `Insertar un cuerpo de tabla`,
's158b6ec6b1fffcb2': `Pausa después de`,
's15d0c0657c1ee08c': `Clave API`,
's1626a7e10a9f9dcc': `Establece la familia de fuentes de la selección`,
's1637c7d1a30629e2': `Cuadro de bordes`,
's1641ab440bf4daa4': `Actualizar este paquete de widgets`,
's166bd56d19670a72': `Zoom`,
's1696c76a23c0834e': `Avanzado: Mostrar paquetes con versiones como 0.x.x en el gestor de paquetes.`,
's16b9446e3a70e1f4': `Atributos`,
's16f205466761e583': `Sin ajuste óptico del tamaño de letra`,
's16f2f1c2c516d307': `Abrir un documento`,
's1749014f3f87fa6a': `Estire`,
's17597a8bb4810524': `Licencia`,
's17bfaaa4e7528bc7': `Bashkir`,
's17fb3f4805f4f4b9': `Eliminar campo`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Crear paquete`,
's18d5c44aae3dc82a': `En línea durante la edición`,
's1988d71ef8060edf': `Insertar una fila de tabla`,
's19abee1277c9bca2': `Samoa`,
's19daf2f26c19543d': `Esquema`,
's1a1acc902e6668e0': `Mostrar formato de texto avanzado`,
's1a5230a71d9285c1': `Capture`,
's1aa1cb63ad44bc6f': `Hueco de columna`,
's1af8b67d1c85c811': `Espacio entre`,
's1b4a36fce2456660': `Familia de fuentes`,
's1c246045629b0016': `Marcar la selección como borrada`,
's1c3fc313a9184670': `Enlace público`,
's1c65f5004a07dcfa': `Gaélico escocés`,
's1c690963f1e2df00': `Aspecto específico de la plataforma`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `¿Quiere una visita corta y guiada?`,
's1d19244f549ec535': `Educación`,
's1d5c7b28e8b50d6d': `Diplomado asociado.`,
's1db591f5a54dbfd3': `Caja de contenido`,
's1dbb9f50e16c92a3': `Radio del borde`,
's1dfb744260fb3a01': `Aislamiento bidireccional`,
's1e9c2c654732cc5f': `Bielorrusia`,
's1eaccbf2d6af8ab5': `Información`,
's1efbfc3937d565bd': `Fondo`,
's1f2b49c1bca2035d': `Catalán`,
's1f74bdf32b51a5fc': `Imagen de fondo`,
's1f7698c061c208c9': `Abrir`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guaraní`,
's20deffeecf2699fb': `Córcega`,
's21d61916eb8d137d': `Cuerpo de la mesa`,
's21d723a1dbcd89c8': `javanés`,
's21f8a2eaf5a70749': `Insertar una etiqueta`,
's2206c42e5b835e6e': `Marcar la selección como abreviatura`,
's22a2348c46a912a0': `Insertar una sección`,
's233ae776268cd44b': `Empresas`,
's236ed7ba747099b0': `Peso de la fuente`,
's2474e7fb1aec9f05': `Prueba`,
's2492f5fb1b05b45e': `Texto`,
's24949d7adbb5a098': `Caja de herramientas`,
's252a52330d32b900': `Metadatos`,
's2540844a4bc4d9ba': `¿Requiere atribución?`,
's255857544a9d5ec0': `Restablecer`,
's255c77900f2b5e0f': `Combinación de colores`,
's256ab831a48c941c': `Elimina todo el formato de texto de la selección`,
's2591806d7b222591': `Restablecer cambios`,
's25e1a07e454c2c11': `Rejilla`,
's262abbaf1d05f009': `Luz suave`,
's266935f2447fcd98': `Más a la izquierda`,
's268ecd1cef45a9a8': `¿Seguro?`,
's2692bc028fed91f1': `Bloq Mayús`,
's27056379e0acfdb0': `Aligerar`,
's27076e66c5d483ba': `Alineación vertical`,
's2712dc5641a33226': `Las cuentas de registro de paquetes están pensadas para desarrolladores y permiten
          configurar uno o varios registros`,
's27cc88818cc46ff6': `Estable`,
's281d957112b10f12': `Editar directamente el HTML del documento`,
's28b6246ce616a548': `Insertar un grupo de columnas de tabla`,
's29a1c26521879b9f': `Reducir`,
's29acfd2778e8c377': `Ocultar el formato de texto avanzado`,
's29b24c06315e9343': `Insertar una entrada`,
's29eb103449472e3b': `Insertar un título (nivel 3)`,
's29ee7434494a0dfe': `Insertar un título (nivel 2)`,
's29f21c34494d614d': `Insertar un título (nivel 1)`,
's29fbfc3449557f72': `Insertar un título (nivel 6)`,
's29ff743449588131': `Insertar un título (nivel 5)`,
's2a031834495bcdb4': `Insertar un título (nivel 4)`,
's2a75c946ef4dcab7': `Varios`,
's2b2ae20d26f78ac2': `Bloque`,
's2b8f50c64be440f7': str`Seleccione 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Pida`,
's2bad2d24def4aa0b': `Salto de línea (CJK lang.)`,
's2ceb11be2290bb1b': `Cancelar`,
's2ced8e8fafb499f6': `Suprimir elemento`,
's2d986d31f8d67357': `Insertar un conjunto de campos`,
's2d995a37cf5e4995': `Inserte un NoScript`,
's2de969afacdaa7a6': `Forma`,
's2df075aface0dab8': `Compartir`,
's2e192b19ed15fcf6': `Página`,
's2e39b99cf23606fa': `Establecer la disposición de los elementos seleccionados`,
's2e4818861000b13f': `Diseño`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `Marathi`,
's2eda5288a65bca1d': `Desbordamiento (y)`,
's2edd6688a65e21f0': `Desbordamiento (x)`,
's2f0bcdffc92a786b': `Flotar a la derecha`,
's2f2044f2431a32d5': `Rúbrica`,
's2f4d4bfbc466d91f': `Albanés`,
's2f8da2cb5f236588': `El nombre del paquete. Debe tener un ámbito, por ejemplo \`@org/pkg\`. `,
's30cce87854901922': `Preescolar`,
's3124653c272f054c': `Color de la regla de columna`,
's314a4f7685c8e824': `Siempre`,
's31c06e226322f065': `Evitar la orfandad`,
's323dcde72b850272': `Acceso público`,
's32911e52ee8ac745': `Insertar una ranura`,
's337a1e9022a8d19f': `Cuadro`,
's33c1450d2822bb0f': `Insertar un pie de figura`,
's33c18d5a4cbffa2a': `Irlandés`,
's33f85f24c0f5f008': `Guardar`,
's342b0cabfa672822': `Ayude al usuario a encontrar su widget`,
's3437e0d9899e7ae1': `Enviar datos telemétricos sobre su uso de WebWriter.`,
's344ea8f4939cdc98': `Color`,
's34dcda3b0f9d5a98': `Alternar url`,
's34f724979a124c50': `Fija el color de fondo del texto seleccionado`,
's355b21b89ce5d9c5': `Detalles`,
's35ae5f4e0fa2777b': `Alineación personalizada`,
's35aeaff1425bca9e': `WebWriter no admite soportes de tipo `,
's35c3125c7750681e': `Cita en bloque`,
's3643189d1abbb7f4': `Código`,
's3649bacefe731bf6': `Alternar caja de herramientas`,
's365280e16a8ea32d': `Copiar la selección`,
's366991b9c9287765': `Derecha`,
's36a194e38d653a26': `Anotación de datos`,
's36b3cefdcb897f15': `Perspectiva`,
's372fae706048ce41': `Even-odd`,
's377e24af9628c37e': `Lista ordenada`,
's37a8c35f6581da5f': `Sin anclaje`,
's37fa3b9cd51c2dfd': `Establece el tamaño de fuente de la selección`,
's380d17664bb69531': `Insertar columna antes de`,
's3815184eb09f0dcf': `Cursor`,
's382a2aa3984474dd': `Cree`,
's38980f98cb07ceb8': `Guardar el documento activo como copia`,
's3914cb410fca44d4': `Importar`,
's3a179f6db2972384': `Posición Rubí`,
's3a5ca02f282d247e': `Comparte...`,
's3ae67088bbefba98': `Paquetes`,
's3b0ab4b52326316f': `Luz`,
's3b3ea038c5d3bb06': `División`,
's3bdad99768e11911': `Explorable`,
's3cb47df8290fa94c': `Insertar una opción`,
's3cf89cb47fdde7e9': `Enlace`,
's3d09398e555ee5f9': `Opciones avanzadas`,
's3d249bb480032121': `Lista`,
's3d3efd1e19bdcfb4': `Anotación de fecha y hora`,
's3d6a732c792ccb9e': `Anotación Ruby`,
's3d93f9ea0c5a13fa': `Imagen`,
's3d9548e211b958ce': `Omitir solapamientos`,
's3e092e9d1ee2c5bb': `Clip`,
's3e78ddc9a48a608d': `Pretty`,
's3eb6d1e6e79ed7c4': `No se han encontrado documentos`,
's3eca5a034978754b': `Borrar la selección`,
's3f06e9abb6ebcb79': `Personajes`,
's3f1e7a3f2b283d3b': `Margen`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gujarati`,
's3f7e097a9b2e6181': `Insertar un artículo`,
's3fd83566dd643d10': `Insertar una leyenda`,
's3fe72792941c18f9': `Texto inferior`,
's3ffcdc5db5e7d0c5': `Invertir`,
's40e3826b7f74a3b5': `Pan (derecha)`,
's40f07d7859284a44': `Línea de base dominante`,
's4101ada154a1b958': `Medio`,
's410c465a5993f82d': `Oportunidad de salto de línea`,
's41322d19c928c603': `TIC`,
's417b90913e05bc17': `Vista previa`,
's418f2020fe996832': `Confirmar cambios`,
's41c724f0698148e9': `Marcar la selección como atajo de teclado`,
's41f65a763f8e44ab': `Grupo de cabecera de tabla`,
's42721130228841b0': `Caja de golpes`,
's429bd646f1cf8bc6': `Las cuentas de LLM Gramática permiten utilizar la API de LLM Gramática para corregir la gramática de un texto.`,
's429dd933ba95549b': `Insertar una dirección`,
's42e470ef1d707a28': `Reproducción automática`,
's42ffdab1291fb3de': `Insertar fila después de`,
's430831017f3f0499': `Inclinación (y)`,
's430bd5017f42511c': `Inclinación (x)`,
's433ba70286202ceb': `Romper todo`,
's441b20a8a50e36b4': `Macedonia`,
's445b8acb9206db6e': `Descartar y cancelar`,
's446a924922651ea0': `Énfasis del texto`,
's44cdba92713de38e': `Zona cuadriculada`,
's45518abd911471d0': `Croata`,
's456a8d744313852a': `Espacio alrededor`,
's4634541f5056a546': `Abjasia`,
's46d4abe6255cb9e1': `Reasignar acceso directo`,
's4730c232e7209c40': `Recorte ambos`,
's474f0eec369d02a4': `Muestra de resultados`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Marcar la selección como anotación de fecha/hora`,
's47ebf3a8fb3b10c1': `Orientación`,
's4802bb8eb52fbdeb': `Portal`,
's4802e47fe2e95134': `Opción`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Sombra de texto`,
's4993444bfd3f3e5e': `Colapso`,
's49ad24935b14e3df': `Quechua`,
's49c560aecfeb8c29': `Máscara`,
's49dd67aed00029ef': `Matemáticas`,
's49e763aed00877a8': `Principal`,
's4a894f57eba1cf1e': `Atajo de teclado`,
's4ac1ad6ecd6bd810': `Misc. ed.`,
's4ad6e9d3c2365c98': `Luz dura`,
's4b2c143acf931122': `Altura de la línea`,
's4b58c01e2578f5e4': `Leyenda`,
's4bbff4e008690da1': `Evitar la página`,
's4c1535f316305a2a': `Inspeccionar la selección`,
's4c402ff5355fd310': `Anulación bidireccional`,
's4caed5b7a7e5d89b': `Inglés`,
's4cb38675a21b2c98': `Tipo de propiedad '\${desc.type}' no admitido (procesamiento como JSON)`,
's4cc8391f172c0cdf': `Abandonar la visita`,
's4d528b416ac8dee2': `Insertar un grupo de encabezamientos`,
's4d546f6c87128d5b': `Espacio primero`,
's4dcb9315f6527f9c': `Ejecutar al recargar`,
's4e191bdb4700a6e9': `Desplazamiento (x)`,
's4e1c7fdb470386ac': `Overscroll (y)`,
's4e2562fe3990e621': `Error de conexión`,
's4e361bf8eef3759a': `Ruptura de palabra`,
's4ea0f21fc2a338a1': `Sube`,
's4eace13b3ed74187': `Comentario adicional`,
's4efee5b48a4593cb': `Bucle`,
's4f26e7cb7c0a8318': `Dibujo vectorial`,
's4fd2e638aabb0bb3': `WebWriter permite incrustar muchas fuentes diferentes. Basta con pegar un enlace al
          contenido de:`,
's4fda04cbc245e18b': `Alfa`,
's4ffac3fb33a2ee9b': `Tailandés`,
's5015a8fb33b98872': `Delgado`,
's50489ffb1bde152e': `Inserción`,
's5068560b8d39663d': `Mapa clicable`,
's517acbf1f96324f9': `Peso`,
's523eb9043213ff0d': `Cursiva`,
's52777d434baeed9b': `Insertar un indicador de progreso`,
's52af5d7ac34c2163': `Tabla Fila`,
's52e0bdc3ee304436': `Insertar un contador`,
's531056f039febd39': `Insertar una selección`,
's536695196d0b6dc3': `Feroés`,
's542fcefa0bbaed86': `Abrir o cerrar la caja de herramientas (sólo en pantallas estrechas, de lo contrario, la caja de herramientas siempre está visible en el lateral).`,
's5432ad3c84273229': `Figura`,
's543906d1db8b2283': `Editar `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Camboya`,
's54897f2764b0e4d0': `Instale este paquete de widgets`,
's54cbfaf2a8da7818': `Pashto`,
's550839f3e4e205bb': `Marcar la selección como muy importante`,
's55905c735052d295': `Pausa temática`,
's5590dbf7e425789d': `Etiqueta`,
's5623aa2f83b05c76': `Tibetano`,
's564d1648b1ceee9f': `Hasta la fecha`,
's565cd5ffb0158c46': `Evitar la región`,
's571a4f19e2f140c7': `Pan (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Volver atrás`,
's5787c6d5b3b5541a': `Recorrido del clip`,
's579c69f419b6caef': `Suave`,
's587ac858dd80f6fa': `Subíndice`,
's58bec0ecd4f3ccd4': `Estricto`,
's59404f5593c32fdc': `Interletraje de fuentes`,
's5941292bb77281ab': `Noruego Bokmål`,
's599dcd2472c75c19': `Párrafo`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Marcar la selección con una anotación de datos`,
's5a356677b61a6b7e': `Moldavia`,
's5b474b5c0ac0c7c4': `Grupo de columnas de la tabla`,
's5b517ac216f9ee62': `De lado`,
's5b8cc9bb61ddce15': `Insertar un párrafo`,
's5bba2ac2e53bd1fd': `Kirguiz`,
's5be80ad6b8301710': `Arranque en línea`,
's5c1ecf88259b79f9': `Presentación`,
's5c2a1a52c0389c30': `Ingeniería`,
's5c63af7695445fcf': `Estilo de texto`,
's5d18ca4c3111be6f': `Insertar una cabecera de tabla`,
's5d87c1e588f48d90': `Práctica`,
's5d929ff1619ac0c9': `Buscar en`,
's5da52af9b083c29a': `Modelo`,
's5dc77784260a7236': `auto`,
's5e27738a2e8eb763': `Iniciar sesión`,
's5e2cba97c0d971bd': `Recargar paquetes`,
's5e53415a6d5719ad': `Ciencias sociales`,
's5e6a7a0c30d2a270': `Omitir solapamientos (auto)`,
's5e9e8e4d21bafedc': `Producción alimentaria`,
's5ed03bb1f3a15949': `Fotografía`,
's5f43af3669b1e098': `Fuente`,
's5feaf7fd7ee567c8': `Palabra de pausa`,
's600fd23c9ce971e8': `Imprimir el documento activo`,
's602bbd28dae2c60f': `Autoarranque`,
's60ff598dfcf2c773': `Bajo derecha`,
's61053f0e3ebbd272': `normal`,
's613c6ff83883c04f': `Tabla Columna`,
's6196153c4b0c1ea0': `Instale`,
's61c017f6d5c303af': `Frisón`,
's61ded17ca3f48c82': `Desplazamiento del subrayado`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Copiar selección`,
's624e31cd4f1b89d4': `Desplazamiento suave`,
's626daf42b1ab7df7': `Alinear a la izquierda`,
's6280bf993915c57a': `Margen de desplazamiento`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Descripción`,
's63dfc5b1c1c27849': `Yiddish`,
's63e03c70f67ebf9c': `Contexto`,
's63e71d20d1eaca93': `Alemán`,
's640bc7710d0143ce': `Rehacer el último cambio deshecho en el documento activo`,
's64dc1fc7e3db45c9': `Crear un nuevo documento`,
's65ac276544ba33cd': `Archivo SVG`,
's66765c420ee578e4': `Espacio uniforme`,
's669b18c6d2d9c95b': `Ninguno`,
's6747dbf4ad6063ba': `Autofinanciación`,
's6787497df07fa97e': `Puede desplazarse por las paradas`,
's67c2b60a506a09e4': `Ed. secundaria`,
's680bd4d926cd5a84': `Conservar 3D`,
's6827930ef1aeaf99': `URL base`,
's684a16f3c711394d': `Sobre la derecha`,
's687e27f036a71b32': `Aislar`,
's68b87d7b61052dc3': `Fila de la tabla`,
's68e0e3a2bab7ce3e': `Evite`,
's690da6b432987c6f': `Copia de seguridad automática de los cambios en el documento actual. Los cambios se restauran cuando se vuelve a cargar WebWriter.`,
's69311c4e25074fb3': `Bachillerato`,
's697400b541fbc3cd': `En`,
's6988ab5d47593a26': `Tienes la última versión de WebWriter.`,
's69a49786a8009f43': `Encuentre paquetes...`,
's69b12144dbb6544d': `Laos`,
's69d88ef4b2618980': `Portada`,
's69fbbdb8ad2a084a': `Oscurecer`,
's6a31eff1ec4f71ad': `Ocultar cara posterior (3D)`,
's6ac62e1c8c66f3bb': `Supercr. compacta`,
's6b585ba37cdb8260': `Heredar`,
's6b61f8abf89586be': `Hebreo`,
's6bd7a02fdf93e653': `Alinear contenidos`,
's6cfc66b824ea05ba': `Bordes nítidos`,
's6d02dc19e21eb49c': `Top`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Vietnamita`,
's6d8b3b8047ed378d': `Mezclar modo de fusión`,
's6d8c02aee480af7a': `Menú`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Insertar un estilo`,
's6e288a119281f4c2': `Representación de texto`,
's6e4c20c6debcd5ca': `Personalizar justificar`,
's6f84199e62584905': `Texto preformateado`,
's6fb3053e7244d326': `Otros campos`,
's70178e04a3b691b6': `Abrir la configuración`,
's7031ca562378bde6': `Precisión geométrica`,
's7060970b5ed20a58': `Interactividad`,
's7136449045eff28c': `Tamil`,
's71940c32987f675f': `Nube WebWriter`,
's71a0549fd71219c9': `Mostrar paquetes inestables`,
's71dec51005acc1e4': `Fila densa`,
's72f2a02e2a5a4ee3': `Medios de comunicación`,
's730182ad28374cda': `Objeto`,
's731678e227a20559': `Este dispositivo`,
's736904f276fbd441': `Ciencias naturales`,
's739544d0c858c633': str`O deje 
          ${0} aquí 
        `,
's73cb20c838e761e1': `Selección de cortes`,
's7417792bbe720149': `Rehacer`,
's741fae02b3dd24f3': `Pixelado`,
's743f778233e42a3f': `Insertar un inciso`,
's744d993d03f29851': `Pantalla`,
's748c0074eff45884': `Manipulación`,
's74aa0039a87141e2': `Elipsis`,
's74b9781bacfcc87c': `Punjabi`,
's74cd20a7aece9b91': `Cuadro de relleno`,
's75109f5307578a61': `Bienvenido a WebWriter`,
's75a27f43413e02c5': `Francés`,
's75d83fc3f0cfab40': `Cabecera`,
's762e5704cc84089d': `Establecer otras opciones de estilo de los elementos seleccionados`,
's77318393dfdb0775': `Eliminar fila`,
's77e594ddcc10c774': `¿Permitir el uso comercial?`,
's782eac2b3e80323d': `Marcar la selección como enfatizada`,
's782f286a79cca35d': `Relativa`,
's78673a3539cb1915': `Arriba a la izquierda`,
's78789724e789221c': `Talla`,
's789ff24c8f03f1a4': `Espacio entre letras`,
's7995733bf97c01cc': `Serbocroata`,
's7a99528e7b64635a': `Occitano`,
's7aaf0c06e69600f1': `Error con `,
's7ae49e142487766c': `Acceso comunitario`,
's7af555180b30a947': `Abrir las herramientas para desarrolladores`,
's7b4ba250601b8667': `Insertar una plantilla`,
's7b560d8693ed8f42': `Vertical`,
's7b9994904c4f5b54': `Tayiko`,
's7bdf0fd5b014d36c': `Importancia fuerte`,
's7beb1e77e82363eb': `Deshacer el último cambio en el documento activo`,
's7c61118554a0ec36': `Máximo (x)`,
's7c95876637f6a9d7': `Filtro`,
's7cb4e55c59663b1c': `Empresa`,
's7cfe12cd14df9950': `Cerrar sesión`,
's7d27db3c9639c6dd': `Alternativa`,
's7d8103f6f06f83d6': `Acolchado`,
's7d864465dddbb50d': `Permitir el cambio de tamaño`,
's7de0e28d6c309a4e': `Permitir acciones táctiles`,
's7dea785045c3cc74': `Pulsar nueva combinación de teclas...`,
's7e0b179d4d1414eb': `Introducir enlace`,
's7e6570f2f1ae320f': `Sintetizar tipos de letra`,
's7ecb1f29332293e5': `Alineación de referencia`,
's7ed13ccddb1bf3c3': `Superposición`,
's7edbe0b213199995': `Licenciatura`,
's7ede1c55e35ce9d6': `Simulación`,
's7f09197a4814079b': `Establecer opciones de interactividad para los elementos seleccionados`,
's7f326a142e856656': `Estilo`,
's7fcb35d23be1e643': `Conjunto de campos`,
's80570196a9ce6d11': `Activar la telemetría`,
's806f84eb0ace116e': `Vea lo que ha seleccionado y modifíquelo. Copie, corte, pegue, fije o modifique el diseño. Ofrece distintas opciones en función de la selección, por ejemplo, el formato del texto.`,
's80a42b81c52d4d8f': `Color de la carita`,
's80b71fc6f43c5ce1': `Suelto`,
's812cbda653daaeba': `Esta función aún no está implementada`,
's814d528c8af55807': `Elemento de la lista de definiciones`,
's81c3d8809658b951': `Cachemira`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Continúe en`,
's8247d32213e35f24': `Insertar un`,
's82665b2ffabc9c0a': `Página web`,
's828b1ecea8715884': `Pan (izquierda)`,
's833bd0422a7ef95d': `Tamaño de la pestaña`,
's83420ad7b6a14db5': `Herramientas de desarrollo`,
's83c15613b6f6f3c8': `Sólo en línea`,
's83cd32b685ccc9b7': `Controla`,
's83f26d02dd7aa681': `Visible`,
's840fa49e8989c028': `Posición/Forma`,
's844a76d1843ceb3c': `Restablecer valores por defecto`,
's84e4e8ae645b82ac': `Arriba a la derecha (y)`,
's84e9c7f8785ca60b': `Insertar un formulario`,
's8517ae4da104b004': `Grupo de columnas de la tabla`,
's85186a61e0d55bac': `Vídeo`,
's851a7deea5984646': `¿Licencia como REA de Creative Commons?`,
's85f9aa6d3ea0e421': `Grupo de pie de tabla`,
's864b0e6270e97246': `Marcar la selección como comentario al margen`,
's8670e5ad3bf0dcf8': `Guardar como`,
's8688d74dd3716d6e': `Atajos de teclado para comandos`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Margen de forma`,
's87cefc710b3567fb': `Contiene`,
's88676f992b2965db': `Estirar el contenido de la celda`,
's886897f2fd4edb99': `Oculto`,
's886c5db2a5579873': `Concepto`,
's888c71e8fcb916d3': `Autoguardado`,
's88a62d29529948fb': `Insertar una tabla`,
's89950d86c8004d4b': `Sin solapamientos`,
's89bca7498f20e041': `Clip de fondo`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Pausa antes de`,
's8a4ff2bd9c13498c': `Registro`,
's8a6585c48ea104e9': `Ocultar celdas vacías`,
's8a9eb438abac7c6a': `Etiquetas`,
's8b0432eecbd8b034': `Actualización`,
's8b7580c35e2aef87': `Arriba a la izquierda (y)`,
's8bc4affa761aa8a2': `Insertar una imagen`,
's8c7f51cb067644c7': `Lista de datos`,
's8d342ecaa9e75b9b': `Relación`,
's8d797888455f4147': `Espacios de descanso`,
's8d83386457e91813': `Deshaga/rehaga sus cambios o previsualice desde la perspectiva del alumno.`,
's8d8643013a7754d1': `Alinear texto`,
's8df30fe2a50d3479': `Insertar una oportunidad de salto de línea`,
's8e715248c3a78446': `Cortar la selección`,
's8f29e48d6b9a1aa8': `Insertar una fila de encabezado de tabla`,
's8f4be9f086eb530f': `Deshacer`,
's8f533296a536965e': `Guardar como...`,
's8fad58c831ecf017': `Contenedor de texto Ruby`,
's8ffe7abcbed8eb43': `Vertical, de izquierda a derecha`,
's90105521fcc40453': `Las cuentas WebWriter Cloud te permiten almacenar documentos en línea y compartirlos
          con tus alumnos. Añade una cuenta aquí y estará disponible como ubicación para guardar,
          cargar, compartir y abrir documentos.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `Paleta de fuentes`,
's90f7c1cf501ea0a7': `Color dodge`,
's91093e0b087911ba': `Posición de énfasis`,
's919e1724f589c9b1': `Ranura`,
's91c5ed7769d00b65': `Insertar incrustación`,
's9219acd5bef6269e': `Bajo izquierda`,
's92548405912d46bf': `Alineación de desplazamiento (y)`,
's9258280591309342': `Alineación rápida de desplazamiento (x)`,
's927d796559f49439': `Antecedentes Origen`,
's92b177e579ef7b97': `Énfasis`,
's92f846b9be2e8e8d': `Marcar la selección como cursiva`,
's93566b84230af4f5': `Insertar una imagen`,
's936aa0b239679585': `Insertar una pausa temática (normalmente se muestra como una línea horizontal)`,
's9370dc6afa716b57': `Frontera`,
's93f083e654a45715': `Bretón`,
's94653c76b2d86a04': `Plazo definido`,
's9485af2e7cd9418f': `Escuela primaria`,
's94d2eee44b292567': `Opciones avanzadas`,
's94d61907ee22a8c1': `Coreano`,
's94eb1effbbb6498b': `Desbordamiento`,
's951aa3a6439f1271': `Marcador de lista`,
's9565553d163fc92a': `Guión`,
's957787fc6b7ea5c0': `Pan (arriba)`,
's95c161f68e5180a5': `Inspeccionar la selección`,
's95d56e58f816d211': `Holandés`,
's95d8e41a64635c7c': `Espacio en blanco`,
's95de7e1eff6c053e': `Horizontal, de arriba abajo`,
's960d3a90ac199368': `Rético-rumano`,
's96532132a29dd542': `Insertar audio`,
's96a045dcade75ad0': `Columna densa`,
's9781a5bb3fcb26a3': `Seleccione primero una empresa`,
's978522fbc9577a7e': `Somalí`,
's97881699a2b21d5b': `Hueco entre filas`,
's97aa76056a81bd36': `Métricas`,
's986facb3ecc9602c': `Lateral, de derecha a izquierda`,
's987abd19fac8cf55': `Sub`,
's9896529e5cb20558': `Archivo externo`,
's98977a87d1b93941': `Restablecer información, estilos y guiones`,
's990d0e0fa2ab00b5': `Gallego`,
's99229574e5692f19': `Groenlandia`,
's99a990f3841ad283': `Archivos de `,
's99b38e000175cc84': `Tachado`,
's99f110d27e30b289': `Título`,
's9ab10fbf4c7a7322': `Posición del subrayado`,
's9abadcc828884d7b': `Área de texto`,
's9b7cd8860c8fc922': str`
          ${0}
          se sobrescribirá. ¿Está seguro? 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Color de fondo`,
's9c8df9626d152d5a': `Término de la lista de definiciones`,
's9ca757effd747da9': `Urdu`,
's9caf10388ab3562f': `Columna de la tabla`,
's9cf68f87b8e6122f': `Azerbaiyán`,
's9d167ef77aed79b6': `Capa`,
's9d2d00982edafabb': `Turco`,
's9d430adc5be110e9': `Fila Inversa`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Supresión`,
's9df571714a1efb44': `Existe una versión autoguardada de esta exploración. ¿Cargarla?`,
's9e28faa598332e2b': `Insertar vídeo`,
's9e3dbb678150edd4': `Establecer familia de fuentes`,
's9e40e59654c8ad67': `Columna`,
's9e85800d3700e31c': `Pista`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Variante de fuente`,
's9f1ecdb3061d9cbc': `Conservar espacios`,
's9faf26107ed49fb9': `Insertar una celda de tabla`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `Transición`,
's9ff3121d30f88d52': `Normal`,
's9ffe1bbe64712bf1': `Lienzo`,
'sa00df4e39c72d3b4': str`
          ${0} no es compatible 
        `,
'sa013e119fec906fb': `Fila`,
'sa01e7bf33563ef72': `Antecedentes`,
'sa126cf8c627cec1e': `Reproducción de imágenes`,
'sa13f72278add7513': `Bajo derecha`,
'sa1647e3b36ec08d7': `Combinar vertical`,
'sa172190ea21f9b1c': `Accede a los ajustes, abre un explorable o crea uno nuevo.`,
'sa1c6c459b9b5115c': `Absolute`,
'sa2cba871f6cdd99f': `Asamés`,
'sa2eff4dad1c119f1': `Plantilla de cuadrícula`,
'sa30c12014e955946': `Ruso`,
'sa30f1981fd1cd441': `Tamaño de letra`,
'sa311a24c1471a974': `Documento`,
'sa352d168b262aa06': `Insertar un pie de página`,
'sa37fee6a52d18063': `Borrar documento`,
'sa39c7ac1d37f3bce': `Marcar la selección como "aislamiento bidireccional".`,
'sa3b4c01623211544': `Fuerza`,
'sa40fd43756fa8913': `Persa`,
'sa417644bef21a9aa': `Tema sin nombre`,
'sa43800e28be1bdbc': `Color de la decoración`,
'sa477cb1825dceb3b': `Sudán`,
'sa492a51a707930fa': `Insertar una cita`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Pie de foto`,
'sa50d3c35533f1d99': `Todos los campos`,
'sa53c5cb03a8fda50': `Fijar la selección como fragmento en la paleta`,
'sa557ae6bee9148a6': `Progreso`,
'sa589e1df65dde0ec': `Definir el tamaño, el relleno y los márgenes de los elementos seleccionados`,
'sa5c371b4bb75e590': `Izquierda`,
'sa5c80e623459ffe4': `Insertar una cabecera`,
'sa5df1bcdba46c3fb': `Leyenda de la figura`,
'sa602e3fd3f2d98fd': `Animación`,
'sa644d580d8a11e60': `Alineación de rubíes`,
'sa645d315510dc09e': `Elija la ruta del disco`,
'sa65d4ad99f1d8c06': `Establecer fondo de texto`,
'sa6607436f60ccc1a': `Estonia`,
'sa6f8d27bca557059': `Mover elementos meta/link/style arriba/abajo en este elemento`,
'sa757645ad842da97': `Conservar las pausas`,
'sa75b95980cd80e78': `Editor`,
'sa7698b3d20a6d1ec': `Desplácese por`,
'sa778acc33947c7b8': `Finalizar recorrido`,
'sa78a67272a4a6f95': `Fórmula matemática`,
'sa79167651dce1e80': `Texto alternativo`,
'sa7af797a46c7d09a': `Pie de tabla`,
'sa7dbe35b758c138d': `Insertar un lienzo`,
'sa7dc6b8ef3f595dc': `Insertar una fuente`,
'sa8279f8211b3950d': `Preservar pausas y espacios`,
'sa8b55cab62e439b5': `Quitar columna`,
'sa8bbe0197d31b423': `Breve descripción`,
'sa9ff3b762365abe6': `Transformar origen (z)`,
'saa02e3762368ff35': `Transformar origen (y)`,
'saa065776236bfa28': `Transformar origen (x)`,
'saa33768e03c45fc8': `Tamaño del archivo`,
'saaad98061a20ac39': `Insertar una fórmula matemática`,
'saab875d8cfcfe712': `Tema`,
'saad4380b9cc6cefd': `Alternar sobre`,
'saaec15c97a9e4245': `Columna Inversa`,
'sab0c57df694a0a09': `Inicio de recorte`,
'sab4d9283896d9422': `Píxeles de resolución instantánea`,
'sab55faae8e165407': `Relleno&lt;br&gt; como hueco`,
'sab5e7d2a069a2951': `Certificado de aptitud profesional`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Alinear a la derecha`,
'sac895c732f350ac5': `Oscuro`,
'saced41ddda8b2354': `Base flexible`,
'sad190f86451081c0': `Nepalí`,
'sad6be321164d08c8': `Matemáticas compactas`,
'sadd352cc7f6f2307': `Aparte`,
'sae098810f946ca7c': `Tagalo`,
'sae185e6af80ec81e': `Sueco`,
'sae1c7f13b7c0c47f': `Inicio`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maorí`,
'sae9d739068eee2c5': `Tártaro`,
'saf312eaeec77a802': `Insertar una lista descriptiva (glosario, lista de términos)`,
'saf3da7c95cb17260': `Marcar la selección como superíndice`,
'saf440a0a592f2835': `Actualización a`,
'saf9e5134ba1a7d30': `Desplazamiento rápido`,
'safc6f203342d09e2': `Activa la vista previa del documento activo`,
'sb0a7e3adf4a125ee': `Arriba a la derecha`,
'sb0a974028c99ca6d': `¿Permitir adaptaciones?`,
'sb0d4f0f7993cf085': `Tamaño de letra`,
'sb0f3327210fe18fc': `Columnas`,
'sb0f93c1c60c0249a': `Base de rubí`,
'sb1494c08c8c720d1': `Definir el color del texto`,
'sb19611adbc88f711': `Avanzado: Mostrar comandos de edición de fuentes, por ejemplo para mostrar el HTML del documento o para añadir estilos y scripts personalizados.`,
'sb206d700d26b14ff': `Subraye`,
'sb233557012dcb328': `Baja`,
'sb26035b596566abf': `Sin nombre`,
'sb2cda80610c8d6ea': `Espacio todos`,
'sb2dc787b0983ebc6': `Lituania`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Centro`,
'sb3ba3276ae93627c': `Insertar un bloque de texto preformateado`,
'sb430f5b4824de0d3': `Elija un diseño`,
'sb43db07b24da018a': `Amárico`,
'sb45f9fb4dba6e71a': `Sin configurar`,
'sb4e003a459464d85': `Kurdo`,
'sb4f0310e6787d098': `Uzbeko`,
'sb4f1dffbb6be6302': `Claro`,
'sb51270e19988f9bd': `Región`,
'sb59d621e3c93cc27': `Bordes de celda compartidos`,
'sb5e9e1776242b028': `Interacciones`,
'sb60bc1250aad44c1': `Span`,
'sb60dd9d23d31ee66': `Doctorado`,
'sb6103872073d369e': `Insertar detalles`,
'sb616811735bfbafd': `Celda de tabla`,
'sb628960829e223bb': `Saltar todos los solapamientos`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Aplicar e importar`,
'sb66e2181a7b5738a': `Al habilitar la telemetría, usted permite la recopilación y conservación de datos de acuerdo con nuestra`,
'sb67e0e7c0869f982': `Diferencia`,
'sb68e83cda6c85af8': `Cabecera de la tabla`,
'sb6b268120592dc53': `Hindi`,
'sb6ca0a8bb3caae69': `Grosor de la decoración`,
'sb70c17f7899f9b01': `Latín`,
'sb71941f552f3504d': `Fijar valor especial`,
'sb740eab4afd5a710': `Flujo automático de la red`,
'sb741b6e0ca589122': `Revertir capa`,
'sb7c77d0415de05cf': `Ejecutar pruebas`,
'sb7fb7568f6883ab8': `Compartir el documento activo`,
'sb85774dc5d18ff0f': `Confirme`,
'sb85b1e36579852a6': `Correo electrónico o contraseña no válidos`,
'sb884fa76bfc55429': `Árabe`,
'sb8a3d4df7d1c5e6b': `Saldo`,
'sb8f610a0e8df91fc': `Luminosidad`,
'sb8f855b49234b81b': `Solicitar`,
'sb905da066c10182c': `Más oscuro`,
'sb940ade1bd81be7e': `Bajo Izquierda`,
'sb9e9a7dd45966756': `Marcar la selección en negrita`,
'sba509fd8ed61d1d5': `Archivo no guardado`,
'sba64d8954d027206': `Opacidad`,
'sba88d90cd6c751b3': `Regla de columna`,
'sbaf0a7c417e388af': `Salud`,
'sbb15d427ee1aa676': `Tigriña`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Filtro de fondo`,
'sbb85a407d730e13d': `Insertar una búsqueda`,
'sbb86c6c96f598bb8': `Mixto`,
'sbba0156f795d8c07': `Editar selección`,
'sbba865d4b437944f': `Atributo`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Desinstalar`,
'sbc5f2a81604baf9b': `Rúbrica 6`,
'sbc5f2b81604bb14e': `Rúbrica 5`,
'sbc5f2c81604bb301': `Rúbrica 4`,
'sbc5f2d81604bb4b4': `Rúbrica 3`,
'sbc5f2e81604bb667': `Rúbrica 2`,
'sbc6953a36ced943f': `política de privacidad`,
'sbd181cd54b8402a4': `Editar la selección`,
'sbd35ee879d9cf770': `Texto en rubí`,
'sbd40f40cbadd38d5': `Eliminar este paquete de widgets`,
'sbd72dc858de95ce8': `Birmano`,
'sbe3c60c65f129daa': `Humanidades`,
'sbe4a7c8f231739b3': `o pegar/soltar/elegir archivo`,
'sbe90de083557ef3e': `Swahili`,
'sbefb6064cba01844': `Insertar un salto de línea`,
'sbf00e1ee999ea94e': `Insertar un script`,
'sbf519920c2017d67': `Colgar`,
'sbfa01f189a68d3e9': `Crecimiento flexible`,
'sbff54e740c4086eb': `Mostrar paquetes desconocidos`,
'sbfff51feacf30196': `Sánscrito`,
'sc0ceaa9843510f67': `Turkmen`,
'sc1611c0558728a2a': `Posición`,
'sc1a155cc25899250': `Grupo de filas de la tabla`,
'sc1aa1f6051b7102a': `Rumano`,
'sc1edebeaef92b7bd': `Disposición fija de la mesa`,
'sc1fff4f356dfb2fb': `Transformar`,
'sc24bda3c061fddf8': `Área clicable`,
'sc252a4e091763606': `Insertar un pie de tabla`,
'sc2536e077514accc': `Desplazamiento`,
'sc275dd00036d16cb': `Cotizaciones carácter`,
'sc28864200d2a3799': `Copiar código QR como imagen`,
'sc2a24a9dd41a9503': `Línea de decoración`,
'sc2b734cca2fa643b': `Pan (abajo)`,
'sc2e2a0dbf03723b7': `Avanzado: Mostrar paquetes de fuentes desconocidas en el gestor de paquetes (Advertencia: Puede ser inseguro)`,
'sc3998b77d72c2932': `Insertar un sitio web (como marco en línea)`,
'sc3ac225273c8316b': `General`,
'sc3cfee84dbbf36ae': `Archivo local`,
'sc3f09a9b6fa4fbed': `En`,
'sc43767deea72e9f3': `Lista descriptiva`,
'sc462bbdd36bcba6b': `Cuadro de referencia`,
'sc4ee3e4ee994dafd': `Ucraniano`,
'sc50d09edf9325339': `Diálogo`,
'sc52b67794c06a0d3': `Origen de la perspectiva (y)`,
'sc52e8b794c0913d6': `Origen de la perspectiva (x)`,
'sc53de149fcaad713': `Entre caracteres`,
'sc546f489f9c0cced': `Conmuta el modo de prueba del documento activo`,
'sc5bcf50d1b578d9f': `Configuración de las fuentes`,
'sc5cb39478b9b7625': `Marcar la selección como subíndice`,
'sc6415b50ff928294': `Elemento de la lista`,
'sc650ff15b20fe9d3': `Girar (z)`,
'sc6578b15b2154365': `Girar (x)`,
'sc65aff15b2183e58': `Girar (y)`,
'sc6da0f4a7e4d710e': `Modificación del idioma de las fuentes`,
'sc74e3567875ce255': `Tanto la etiqueta de su widget como el nombre de su paquete NPM`,
'sc7eb080b96e244df': `Malayo`,
'sc8ac7ef92b95df3f': `Mover (x)`,
'sc8af536e2084ade0': `Paleta`,
'sc8b022f92b992bc2': `Mover (y)`,
'sc8b39af92b9c2d81': `Mover (z)`,
'sc8d2c7f6c33a2b32': `Definir el estilo del texto (alineación, sangría, espaciado, etc.) de los elementos
          seleccionados`,
'sc8fa0e3de389ef1c': `Ajuste del tamaño de fuente`,
'sc9474bf7a0668d73': `Resumen`,
'sc94e314312a8900c': `Checa`,
'sc980855a000b76ea': `Fondo`,
'sc98b103772de63f4': `En finés`,
'sca7cfe2bef51b2a5': `Raíz`,
'sca7fed2bef53cb99': `Papel`,
'scabe6ecee5e01fd2': `Maltés`,
'scace301a88231cce': `Insertar`,
'scbc55f622ec078c1': `Ver cuadro`,
'scbe537fc38ff4c13': `Autocolumnas de rejilla`,
'scc1db59d292cbc4c': `Sección`,
'scc56b218a2689c42': `Armenio`,
'scc5ba32e0de06744': `Sesotho`,
'scd15088c39fe9edf': `Caja acolchada`,
'scd9cedeb5ece3adb': `Guión`,
'scdf536b65be39ec5': ` Crear/importar`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Ideográfico`,
'sceecdd0bb404bc17': `Insertar un grupo de opciones`,
'scf00d48fd5953a03': `Griego`,
'scf932840a69dbb7c': `Portugués`,
'scf932a8577057752': `Pie de página`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `Abajo a la derecha`,
'sd01178c54f648118': `Columnas de balance`,
'sd03bff50f87f82d4': `Carácter silábico`,
'sd05a155fe09c2866': `En línea al utilizar`,
'sd0864ea6cb6ef22e': `Comunidad`,
'sd10fdbe6caf9a998': `Salto de línea`,
'sd121d3b959b7888d': `Optimizar la velocidad`,
'sd1a78e667a1a139f': `Marcar la selección como inserción`,
'sd1cffad290ea5b3b': `Mantenga todos`,
'sd1f10284eeb17b25': `Fiyi`,
'sd1f44f1a8bc20e67': `Correo electrónico`,
'sd1f81984eeb7c0e8': `Rellene`,
'sd29dc07235eea0f5': `Presupuesto`,
'sd2addf69477cd4b4': `Importar paquete`,
'sd2ed26defc646d47': `Filtro de fondo`,
'sd2ef82b8ea877c6d': `Afrikaans`,
'sd319aae1401f1e19': `Fijo`,
'sd3a288c1094b8a63': `Ancho de la regla de columna`,
'sd3c65ef5c380c046': `Insertar`,
'sd3dcb76f7b28adb8': `Letón`,
'sd3eca1e0f4209f6e': `Recortar todo`,
'sd3f402df8619ddcd': `Esta información sobre usted se añade automáticamente a los nuevos documentos. Puede
          modificarla para cada documento en el editor de metadatos.`,
'sd4368b12645d3c0f': `Insertar un portal`,
'sd452cebf4a0313d1': `Mostrar comandos de edición de fuentes`,
'sd48cc52117f4d68b': `Italiano`,
'sd52660ee947ca58b': `Insertar una columna de tabla`,
'sd588d17a1b25c220': `Desbordamiento de texto`,
'sd5be6f6d85fc0c9b': `Zulú`,
'sd5bf67958b08b4cf': `Educación superior.`,
'sd5cf95145e4d89ca': `Desprender este fragmento`,
'sd5fd9d11a92f5b1d': `Abajo a la izquierda (y)`,
'sd60c9bbc51375635': `Insertar un botón`,
'sd66c4767fa3dde28': `Color de acento`,
'sd679c8b1bf8cc8a5': `Pequeñas capitalizaciones`,
'sd7086c4425c53c80': `Familia de fuentes`,
'sd837f42ac7cbfb58': `Forma (exterior)`,
'sd88076d2994ee0fb': `Exclusión`,
'sd89a2e529b31ef43': `Volver a`,
'sd8a345e95668b73b': `Vertical, de derecha a izquierda`,
'sd8ce9e57270b030d': `Fuente estirada`,
'sd8ecf227c7c49331': `Matemáticas`,
'sd8f923198e0c5c6a': `Fin`,
'sd9c21e5f60d6bdd8': `Danés`,
'sd9ff8e2612e63d50': `Dimensionado de los bordes`,
'sda2d76b976502a8d': `Abre...`,
'sda344aacb837387e': `Posición en el contenedor`,
'sda5b6fa8b771f996': `Flotador izquierdo`,
'sda9254d1f1228e1a': `Húngaro`,
'sdb1595f5c742dfbb': `Entrada`,
'sdb711380a28fec75': `Insertar una lista (ordenada)`,
'sdb73788b3c975f16': `Auto`,
'sdbee7e0523a23a42': `Abajo a la derecha (y)`,
'sdc48456f9a27ae02': `Generador`,
'sdc70d81cf6c28533': `Georgiano`,
'sdd1ff479d04ac140': `Público`,
'sdd2fc8919a9c3111': `Modo de fusión del fondo`,
'sdd35b688281b6dea': `Japonés`,
'sddc49047f66a64ab': `Sin descripción`,
'sdef34fe08bb28b09': `Chino (simplificado)`,
'sdf62e305e1594805': `Marcar la selección con una anotación ruby`,
'sdf946172dfa0328f': `Superíndice`,
'sdf9bc5d9b7f3e3de': `Alineación`,
'se036b53f145441cd': `Contenido mixto`,
'se06f459fccdc3ce9': `Alinear la última línea de texto`,
'se0a782a8be8e018b': `Noruega`,
'se0cda6b80a1bb50f': `Eslovaquia`,
'se0f67eae944f8f94': `Silenciar`,
'se1312d6528f9a259': `Yoruba`,
'se16c5e66886fbc59': `Artículo`,
'se1f5bb0386c88f96': `Fija el color del texto seleccionado`,
'se219da7b1e955c65': `Formato claro`,
'se25e4f2cb77b8be8': `Lenguaje para la interfaz WebWriter y nuevos documentos`,
'se2796c5824ec8916': `Visibilidad del contenido`,
'se308836a594808b6': `Cingalés`,
'se36c5b1baf5e0660': `En cualquier lugar`,
'se39c065efa467782': `Vasco`,
'se3b4c857f91f80d7': `Atajos de teclado`,
'se47baf2fd16b9d2b': `Plantilla`,
'se48bd9e6c2a3109d': `Cuentas`,
'se58467472725ad0c': `Resolución de imagen`,
'se58f06c2b0583ff7': `Elegir coordenadas`,
'se5dc1e97fb743ade': `Espaciado`,
'se619a501d1bfe6a5': `Envolver`,
'se62385ac082368d2': `Marcar la selección como fuente de cita`,
'se6297163cac9d276': `Editar fuente`,
'se633223a0b88625e': `Colocación de celdas`,
'se638417c560cfe5c': `Romper por dentro`,
'se64f418b4e733b6c': `Insertar una salida`,
'se6cdad455e2d8c02': `Insertar una división`,
'se79c0a3ac70d8fb3': `Ratio asp. (x)`,
'se79fae3ac710dc36': `Ratio asp. (y)`,
'se7fad370d8fb4cec': `Optimizar la legibilidad`,
'se8a94b4effa2033e': `Alfabético`,
'se95d4e55ea186d9a': `Color de la barra de desplazamiento`,
'se96d43a515b8451c': `Eslovenia`,
'se96fd76ba1b2975a': `Central`,
'se9ac05f36b004eb0': `Ocultar el recorrido introductorio. Desactivar para que el tour se muestre de nuevo.`,
'se9b1fec72ffd8f48': `Local`,
'sea24bdcaa2bd2dec': `Chasquido obligatorio`,
'sea52df2b70a5c10d': `Ruby`,
'sea6e7291e27ec53f': `Activa el editor de metadatos`,
'sea896ed51ad33287': `No hay estilos específicos disponibles`,
'seaaaeb09e3b4e78b': `Comandos de edición`,
'seabae79729c4b2ad': `Alternar correo electrónico`,
'seaecc8267bad6234': `Secundaria`,
'seaf97719986faf4f': `Brecha`,
'seb19675a580f0628': `Evitar la columna`,
'seb4e52ef5ec7a7dc': `Colores/Efectos`,
'seb8982ae8c3cdcc5': `Indonesia`,
'sebbced89e0db2894': `Primera base de referencia`,
'sec02109a0dd2a6c8': `Color de énfasis`,
'sec2557a35b702525': `Variable`,
'sec2da4aa7a02b925': `Islandia`,
'sec30fbb20f102670': `Insertar resumen`,
'sec8b0b6c729816b6': `Rúbrica Grupo`,
'seccd05955adb76bc': `Póster`,
'sed17285cd25d6389': `Directorio donde se encuentra package.json`,
'sed318ec045c5144f': `En`,
'sed713f1b916fb469': `Distancia entre bordes (x)`,
'sed74a31b9172942c': `Distancia entre bordes (y)`,
'sed86bd0deb2e5372': `Transformar texto`,
'see2fcaedf9743ec6': `Ubicación`,
'seec6798afe90ffc8': `Imprimir`,
'sef00c258bc1ecf1e': `Este explorable tiene cambios sin guardar.`,
'sef23dd271edd4a8b': `Abajo a la izquierda`,
'sef24caccbd4645ef': `Flexo retráctil`,
'sef49aec68fd1dc66': `Nombre`,
'sef73fe18e351eb35': `Palabras clave`,
'sef75f458d77491af': `Grupo de opciones`,
'sefcf950b3cc4fc3b': `Idioma`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Contenido`,
'sf0cab2483f66aa2e': `A medida`,
'sf0e261e04eda82ff': `Apariencia`,
'sf1045382c1fd9a85': `Colores de impresión exactos`,
'sf14c35392ec7bf10': `Esta función no está disponible en Firefox. Sí está disponible en Chrome o Edge.`,
'sf14f9d5f9f6ca342': `Más ligero`,
'sf1868dc19e3917bb': `Español`,
'sf190149f9d8bbb2a': `Modo de escritura`,
'sf1e79171c4856543': `¿Está seguro? Esta acción no puede ser revertida, todos tus ajustes serán borrados y
          reiniciados.`,
'sf21c1f60c7515f44': `Marcar la selección como salida de muestra`,
'sf21fb4f4b9e8911f': `Anchura`,
'sf22a3737146ec910': `WebWriter puede incrustar SVG directamente en el documento.`,
'sf2514d5dc78b1654': `Insertar widget`,
'sf28903d4ca0ddcfc': `Eliminar esta cuenta`,
'sf2ab37af0abc55ef': `Ocultar recorrido de introducción`,
'sf2bdb0b4d7b9c039': `Bengalí`,
'sf2cbb5e519264e67': `Cambiar el tamaño horizontal y verticalmente`,
'sf2d5cbc2fe0ad65a': `Pegajoso`,
'sf2d96d0eb32cb81f': `Composición de la animación`,
'sf2de3dbe2108637a': `Representación de formas`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `En línea`,
'sf39736a666dbb038': `Insertar una pista`,
'sf3c4da68b08a2590': `Malgache`,
'sf471ec2496f904cc': `Descartar cambios`,
'sf4849bc200e279ed': `Leyenda de la tabla`,
'sf486ca1fdbe08645': `Insertar una cifra`,
'sf4b537d4cbd8f5fd': `Texto superior`,
'sf4e0e02a5277ef23': `Insertar un área de texto`,
'sf4f067d41efd4b83': `Escala (y)`,
'sf4f3cbd41f002b46': `Escala (x)`,
'sf4fa67d41f05a008': `Escala (z)`,
'sf5197db2d5f2926a': `Gire`,
'sf52d840949a980d1': str`
          ${0}
          se borrará permanentemente. ¿Está seguro? 
        `,
'sf55d634dcc743595': `Servicios`,
'sf59c9081d106dd9c': `Marcar la selección como variable`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Borrar un documento`,
'sf65df67a03bebe4b': `Obligatorio para este widget`,
'sf6673729c03ae999': `Restablecer WebWriter`,
'sf67571992e7dc88e': `Periodo completo`,
'sf6b4934598f7ed10': `Permitir selección`,
'sf6e1665c7022a1f8': `Contraseña`,
'sf79e0d78b56444f1': `Extremo en línea`,
'sf7a5f7a7c80c3082': `Ambos`,
'sf7c0eba7c822e3d6': `Negrita`,
'sf86bd4d2982f3b74': `Marcar la selección como código`,
'sf8e82313fa411494': `Marcar la selección como enlace`,
'sf955eff73fb6b573': `Serbio`,
'sf9929e2d356260c5': `Multiplique`,
'sf993bb199fefbe04': `Todos`,
'sf9ecf969dd4b8164': `Ambos bordes`,
'sf9f2c719a04066ec': `Aplicación`,
'sfa49a5bb1a5d353e': `Acceso privado`,
'sfa59c7777e2a0eeb': `Insertar una lista de datos`,
'sfaa0a67db5c11f72': `Sangría en la primera línea de texto`,
'sfb231a52211b133f': `Sin ajuste de texto`,
'sfb68cae41d749423': `Inicial`,
'sfb9b6edb0ed378c9': `Fuente de citas`,
'sfbbab09dbe553571': `Insertar un dibujo vectorial (SVG)`,
'sfc00292e778b67e2': `Contador`,
'sfc63e31ac7c956ed': `Seleccione`,
'sfc815c9078bba30a': `Descargar código QR como imagen`,
'sfcdd8e672c75b713': `Dirección`,
'sfcebd18506f1e535': `Flujo`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `Salida`,
'sfdb1e4d90981a535': `Compartir este documento`,
'sfdeef3dccf409f81': `Esta palabra clave es necesaria para los widgets`,
'sfe6e758ad2603c1d': `Máster`,
'sfee1c12daf838935': `Quemadura de color`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Insertar un diálogo`,
'sffa395f64ec6ac36': `Búlgaro`,
'sffdadf0a576fd802': `Altura`,
'spaceKey': `Espacio`,
'tabKey': `⭾ Tab`,
'upKey': `↑ Arriba`,
's2739460e44320108': `Chinese (Traditional)`,
'scbf29ce484222325': ``,
    };
  